import SelectBox from "./elements/SelectBox";
import SelectRes from "./elements/SelectRes";
import InputText from "./elements/InputText";
import ColorInput from "./elements/ColorInput";
import GradientInput from "./elements/GradientInput";
import FontSize from "./elements/FontSize";
import FontWeight from "./elements/FontWeight";
import FontFamily from "./elements/FontFamily";
import TextareaInput from "./elements/TextareaInput";
import EditAll from "./elements/EditAll";
import SimpleList from "./elements/SimpleList";
import BGImage from "./elements/BGImage";
import ImageUploader from "./elements/ImgUploader";
import ListComponent from "./ListComponent";
import SubscriptionForm from "./SubscriptionForm";
import RichTextEditor from "./elements/RichTextEditor";

import * as CUSTOMCOMPS from "./custom";
import PaddingMargin from "./elements/PaddingMargin";
import { twdClass } from "../../constants/tailwind.constants";
import { RowPerColumns } from "./elements/RowPerColumns";

import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector} from "react-redux";
import {
  SELECT_ELEMENT
} from "../../constants/action.constants";
import {RenderArea} from "./ui-elements/RenderArea";

const RenderElements = ({ element, data, updateElementValue, inputArgs={} }) => {
  /*const ref = useRef(null)
  const [isSelected, setSelected] = useState(false); 
  const dispatch = useDispatch(); 
  useEffect(()=>{
    if(inputArgs.selected && ref.current) {     
      const rect = ref.current.getBoundingClientRect();
      //const ofw=elementRef.current.offsetWidth
      //const off= {top:rect.top-trigParent.top, left:rect.left-trigParent.left, width:rect.width, height:rect.height}
      //updateTriggerable({path, offset:off})
      dispatch({ type: SELECT_ELEMENT, data: {top:rect.top} })
      //console.log("RenderElements rect", element.updateTo, rect); // Should now be non-zero
      setSelected(true)
      setTimeout(()=>{
        setSelected(false)
      }, 1000)
    }
  }, [inputArgs.selected])*/

  
  //if(element.hoverStyle==true) console.log("ELEMENT", element.label, element)  
  let out=''
  if (element.inputType === "select") {
    out = (
      <SelectBox
        element={element}
        data={data}
        updateElementValue={updateElementValue}
        inputArgs={inputArgs}
      />
    );
  } else if (element.inputType === "selectres") {
    out = (
      <SelectRes
        element={element}
        data={data}
        updateElementValue={updateElementValue}
        inputArgs={inputArgs}
      />
    );
  }  else if (element.inputType === "text") {
    out = (
      <InputText
        element={element}
        data={data}
        updateElementValue={updateElementValue}
        inputArgs={inputArgs}
      />
    );
  } else if (element.inputType === "textarea") {
    out = (
      <TextareaInput
        element={element}
        data={data}
        updateElementValue={updateElementValue}
        inputArgs={inputArgs}
      />
    );
  } else if (element.inputType === "richtext") {
    out = (
      <RichTextEditor
        element={element}
        data={data}
        updateElementValue={updateElementValue}
      />
    );
  } else if (element.inputType === "simplelist") {
    out = (
      <SimpleList
        element={element}
        data={data}
        updateElementValue={updateElementValue}
        inputArgs={inputArgs}
      />
    );
  }else if (
    element.inputType === "color" ||    
    element.inputType === "backgroundcolor"
  ) {
    //if(element.styleStates==true) console.log("Color ELEMENT", element.label, element)
    out = (
      <ColorInput
        element={element}
        data={data}
        updateElementValue={updateElementValue}
      />
    );
  } else if (    
    element.inputType === "gradient"
  ) {
    out = (
      <GradientInput
        element={element}
        data={data}
        updateElementValue={updateElementValue}
      />
    );
  } else if (element.inputType === "fontsize") {
    out = (
      <FontSize
        element={element}
        data={data}
        updateElementValue={updateElementValue}
      />
    );
  } else if (element.inputType === "fontweight") {
    out = (
      <FontWeight
        element={element}
        data={data}
        updateElementValue={updateElementValue}
      />
    );
  } else if (element.inputType === "fontfamily") {
    out = (
      <FontFamily
        element={element}
        data={data}
        updateElementValue={updateElementValue}
      />
    );
  } else if (
    element.inputType === "bgimage" ||
    element.inputType === "backgroundimage"
  ) {
    out = (
      <BGImage
        element={element}
        data={data}
        updateElementValue={updateElementValue}
      />
    );
  } else if (
    element.inputType === "padding" ||
    element.inputType === "margin"
  ) {
    out = (
      <PaddingMargin
        element={element}
        data={data}
        updateElementValue={updateElementValue}
      />
    );
  } else if (element.inputType === "image") {
    out = (
      <ImageUploader
        element={element}
        data={data}
        updateElementValue={updateElementValue}
        inputArgs={inputArgs}
      />
    );
  } else if (element.inputType === "list") {
    out = (
      <ListComponent
        element={element}
        data={data}
        updateElementValue={updateElementValue}
        inputArgs={inputArgs}
        sortable={element.sortable ? element.sortable : false }
      />
    );
  } else if (element.inputType === "columns") {
    out = (
      <RowPerColumns
        element={element}
        data={data}
        updateElementValue={updateElementValue}
      />
    );
  } else if (element.inputType === "componentTag") {
    out = (
      <SubscriptionForm
        element={element}
        data={data}
        updateElementValue={updateElementValue}
      />
    );
  } else if (element.inputType === "custom") {
    out = elementHOC(
      CUSTOMCOMPS[element.component],
      data,
      element,
      updateElementValue
    );
  } else if (element.inputType === "section") {
    out = (
      <div
        className={twdClass(
          "pt-3 text-blue-500 border-t-2 border-blue-200 my-3"
        )}
      >
        {element.label}
      </div>
    );
  } else if (
    element.inputType === "editall"
  ) {
    //if(element.styleStates==true) console.log("Color ELEMENT", element.label, element)
    out = (
      <EditAll
        element={element}
        data={data}
        updateElementValue={updateElementValue}
      />
    );
  }
  if(out) return (<RenderArea {...{path:element.updateTo}}>{out}</RenderArea>)
  return <></>;
};

export default RenderElements;

const elementHOC = (Wrapper, data, element, updateElementValue) => {
  return (
    <Wrapper
      data={data}
      element={element}
      updateElementValue={updateElementValue}
    />
  );
};
